// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rIb4","field":"styles_field__a068j","fieldCol":"styles_fieldCol__3bRy7","diffCol":"styles_diffCol__6EbFA","diff":"styles_diff__1WGpu"};